import { api } from './api';

export async function fetchTeam(teamId) {
    const apiInst = await api();
    const response = await apiInst.get('teams/' + teamId);
    return response.data;
}
